import React, { ChangeEventHandler, CSSProperties, FC, ReactNode } from 'react';
import { clsx } from 'clsx';
import styles from './Checkbox.module.css';
import { useTheme } from '../../../hooks/useTheme';
import Check from './Check';

export interface CheckboxProps {
  children?: ReactNode;
  id: string;
  name?: string;
  value?: string;
  checked?: boolean;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  containerStyle?: CSSProperties;
  checkStyle?: CSSProperties;
  boxStyle?: CSSProperties;
  labelBoxCellStyle?: CSSProperties;
  labelTextCellStyle?: CSSProperties;
}

const Checkbox: FC<CheckboxProps> = ({
  children,
  id,
  name = '',
  value,
  onChange = (): void => undefined,
  checked = false,
  boxStyle = {},
  containerStyle = {},
  labelBoxCellStyle = {},
  labelTextCellStyle = {},
  checkStyle = {},
}) => {
  const { iconsPrimaryNone, bodytextDefaultNone } = useTheme();

  const checkContainerClasses = clsx(
    styles.checkContainer,
    checked && styles.checkContainerChecked,
  );

  const checkbox = (
    <>
      <input
        className={styles.visuallyHiddenInput}
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        type="checkbox"
        checked={checked}
      />
      <div
        className={checkContainerClasses}
        style={{
          ...iconsPrimaryNone,
          ...boxStyle,
          borderColor: iconsPrimaryNone?.color,
          backgroundColor: checked
            ? iconsPrimaryNone?.color
            : (boxStyle.backgroundColor ?? 'transparent'),
        }}
      >
        {checked ? <Check checkStyle={checkStyle} /> : null}
      </div>
    </>
  );

  if (!children) return <div style={containerStyle}>{checkbox}</div>;

  return (
    <label className={styles.label} htmlFor={id} style={containerStyle}>
      <div className={styles.labelTable}>
        <div className={styles.labelBoxCell} style={labelBoxCellStyle}>
          {checkbox}
        </div>
        <div
          className={styles.labelTextCell}
          style={{ ...labelTextCellStyle, ...bodytextDefaultNone }}
        >
          {children}
        </div>
      </div>
    </label>
  );
};

export default Checkbox;
